// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS DU SIDEBAR */
.divGlobal {
  width: 100%;
  height: 100vh;          
  overflow: hidden;         
  display: flex;
}
.siderSexion {
  position: fixed;
  /* top: 4; */
  left: 0;
  height: 100vh;
  /* width: 17%; */
  min-width:18% !important;
  /* background-color: #001529; */
  z-index: 1000;
}
.contenuSexion {
  margin-left: 17%;        
  height: 100vh;          
  overflow-y: auto;         
  padding: 2.4%;
  scrollbar-width: none;     
  -ms-overflow-style: none; 
  background-color: #fff;
  text-align: justify;

}
.contenuSexion::-webkit-scrollbar {
  display: none;
}
.menuSexion {
    padding: 1%;
    margin-top: 11%;

}
.menuSexion .ant-menu-item {
  text-align: left;
  overflow: visible;
  text-overflow: unset;  
    white-space: normal; 
}
.menuSexion .ant-menu-item-selected {
  background-color: #43CE0C !important; 
  color: white !important;
}
.menuSexion .ant-menu-item:hover {
  color: #43CE0C !important;
}
.menuSexion .ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: #43CE0C !important;
}
:where(.css-dev-only-do-not-override-ut69n1).ant-layout-sider {
    background: #ffffff;
}

.breadcrumbSexion {
    margin-top: -2%;
    margin-left: 2%;
}








/* CSS DU TOPBAR */
.divGlob {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 1100;
    background-color: #e8fce2;
    /* padding: 0 2%; */
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    /* height: 8vh; */
}
.divLogo {
display: flex;
align-items:start;
justify-content: start;
}
.imgSexion {
    width: 4%;
    margin-right: 0.2%;
    margin-top: 0.6%;
}
.divNomApplication {
    padding: 0;
    margin-top: 0.1%;
    text-align: left;
    font-weight: bold;
}
.divAvatar {
    display: flex;
    align-items:center;
    justify-content:flex-end;
    margin-top: -5%;
    padding: 1.3%;
}






`, "",{"version":3,"sources":["webpack://./src/components/layout/layout.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;;AAErB;AACA;EACE,aAAa;AACf;AACA;IACI,WAAW;IACX,eAAe;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;IAClB,mBAAmB;AACvB;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;;;;;;;;AASA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;IACxC,iBAAiB;AACrB;AACA;AACA,aAAa;AACb,iBAAiB;AACjB,sBAAsB;AACtB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,aAAa;AACjB","sourcesContent":["/* CSS DU SIDEBAR */\r\n.divGlobal {\r\n  width: 100%;\r\n  height: 100vh;          \r\n  overflow: hidden;         \r\n  display: flex;\r\n}\r\n.siderSexion {\r\n  position: fixed;\r\n  /* top: 4; */\r\n  left: 0;\r\n  height: 100vh;\r\n  /* width: 17%; */\r\n  min-width:18% !important;\r\n  /* background-color: #001529; */\r\n  z-index: 1000;\r\n}\r\n.contenuSexion {\r\n  margin-left: 17%;        \r\n  height: 100vh;          \r\n  overflow-y: auto;         \r\n  padding: 2.4%;\r\n  scrollbar-width: none;     \r\n  -ms-overflow-style: none; \r\n  background-color: #fff;\r\n  text-align: justify;\r\n\r\n}\r\n.contenuSexion::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n.menuSexion {\r\n    padding: 1%;\r\n    margin-top: 11%;\r\n\r\n}\r\n.menuSexion .ant-menu-item {\r\n  text-align: left;\r\n  overflow: visible;\r\n  text-overflow: unset;  \r\n    white-space: normal; \r\n}\r\n.menuSexion .ant-menu-item-selected {\r\n  background-color: #43CE0C !important; \r\n  color: white !important;\r\n}\r\n.menuSexion .ant-menu-item:hover {\r\n  color: #43CE0C !important;\r\n}\r\n.menuSexion .ant-menu-submenu-selected > .ant-menu-submenu-title {\r\n  color: #43CE0C !important;\r\n}\r\n:where(.css-dev-only-do-not-override-ut69n1).ant-layout-sider {\r\n    background: #ffffff;\r\n}\r\n\r\n.breadcrumbSexion {\r\n    margin-top: -2%;\r\n    margin-left: 2%;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* CSS DU TOPBAR */\r\n.divGlob {\r\n    position: sticky;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 1100;\r\n    background-color: #e8fce2;\r\n    /* padding: 0 2%; */\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n    /* height: 8vh; */\r\n}\r\n.divLogo {\r\ndisplay: flex;\r\nalign-items:start;\r\njustify-content: start;\r\n}\r\n.imgSexion {\r\n    width: 4%;\r\n    margin-right: 0.2%;\r\n    margin-top: 0.6%;\r\n}\r\n.divNomApplication {\r\n    padding: 0;\r\n    margin-top: 0.1%;\r\n    text-align: left;\r\n    font-weight: bold;\r\n}\r\n.divAvatar {\r\n    display: flex;\r\n    align-items:center;\r\n    justify-content:flex-end;\r\n    margin-top: -5%;\r\n    padding: 1.3%;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
